let _rightClickHandler = null;
let _copyHandler = null;
let _pasteHandler = null;
let _cutHandler = null;

let _lastMouseEventTime = 0;
const MOUSE_THROTTLE = 200;

export const mouseState = {};
export const mouseGetters = {};
export const mouseMutations = {};

export const mouseActions = {
  startMouseProctoring({ dispatch }) {
    if (_rightClickHandler) return;

    // Right Click
    _rightClickHandler = (e) => {
      e.preventDefault();
      const now = Date.now();
      if (now - _lastMouseEventTime < MOUSE_THROTTLE) return;
      _lastMouseEventTime = now;
      dispatch("triggerViolation", {
        reason: "Right click attempt detected",
        isLog: true,
      });
    };

    // Native Clipboard Handlers (Directly catch context menu or menu actions)
    _copyHandler = (e) => {
      e.preventDefault();
      const now = Date.now();
      if (now - _lastMouseEventTime < MOUSE_THROTTLE) return;
      _lastMouseEventTime = now;
      dispatch("triggerViolation", "Copy Attempt detected");
    };

    _pasteHandler = (e) => {
      e.preventDefault();
      const now = Date.now();
      if (now - _lastMouseEventTime < MOUSE_THROTTLE) return;
      _lastMouseEventTime = now;
      dispatch("triggerViolation", "Paste Attempt detected");
    };

    _cutHandler = (e) => {
      e.preventDefault();
      const now = Date.now();
      if (now - _lastMouseEventTime < MOUSE_THROTTLE) return;
      _lastMouseEventTime = now;
      dispatch("triggerViolation", "Cut Attempt detected");
    };

    window.addEventListener("contextmenu", _rightClickHandler);
    document.addEventListener("copy", _copyHandler);
    document.addEventListener("paste", _pasteHandler);
    document.addEventListener("cut", _cutHandler);
  },

  stopMouseProctoring() {
    if (_rightClickHandler) {
      window.removeEventListener("contextmenu", _rightClickHandler);
      _rightClickHandler = null;
    }
    if (_copyHandler) {
      document.removeEventListener("copy", _copyHandler);
      _copyHandler = null;
    }
    if (_pasteHandler) {
      document.removeEventListener("paste", _pasteHandler);
      _pasteHandler = null;
    }
    if (_cutHandler) {
      document.removeEventListener("cut", _cutHandler);
      _cutHandler = null;
    }
  },
};
